<template>
  <div>
    <div 
      v-for="(control,i) in modePointControls"
      :key="`lpc_${i}`">
      <b>{{ $t(`sport.controls.${control.code}.short`) }}:</b> {{ $t(`sport.controls.${control.code}.description`) }}
    </div>
    <div 
      v-for="(control,i) in mode==='basic' && match.actionBasicControls.length > 0 ? match.actionBasicControls: match.actionControls"
      :key="`lapc_${i}`">
      <b>{{ $t(`sport.controls.${control.code}.short`) }}:</b> {{ $t(`sport.controls.${control.code}.description`) }}
    </div>
  </div>
</template>

<script>
// const debug = require('debug')('OD::Leyend')

export default {
  name: 'Leyend',
  components: {},
  props: {
    match: {
      type: Object,
      required: true,
    },
    mode: {
      type: String,
      required: true,
    },
  },
  data() {
    return {}
  },
  computed: {
    modePointControls() {
      return this.mode === 'basic' ? this.match.pointBasicControls : this.match.pointControls
    },
  },
  watch: {},
  created() {},
  beforeDestroy() {},
  methods: {},
}
</script>

<style lang="scss" scoped>

</style>
